import { render } from "./Value.vue?vue&type=template&id=dc19fec0&scoped=true&ts=true"
import script from "./Value.vue?vue&type=script&lang=ts"
export * from "./Value.vue?vue&type=script&lang=ts"

import "./Value.vue?vue&type=style&index=0&id=dc19fec0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc19fec0"]])

export default __exports__